import React from 'react';
import PropTypes from 'prop-types';

function InitialsSVG({ width, height, style }) {
  return (
    <svg viewBox="0 0 188.8 324.3" width={width} height={height} style={style}>
      <style>{'.st0{fill:#2696a1}'}</style>
      <path
        id="initials"
        className="st0"
        d="M188.8 167.3c-.4-24.6-18.1-55.7-46.5-49-30.1 6.8-51.1 32.9-69 56.4.5-22.5 1.5-44.9 1.7-67.4-1.1-17.3 3-36.1-2.8-52.5-6.9-12.4-26.9-4.2-23 9.5-.8 23.4-20.7 73.1-47.5 74.7-.6-.1-1.2-.3-1.7-.5 24.4 7.9 47.6-17.3 56.1-38.2 6.2 29.2 8.8 59 7.6 88.8-9.7 15.8-18.5 32.2-26.3 49.1l.7-1.7c-45 87.6 25.1 110.1 33.3 65.3 5.4-35-1-70.7 1.6-105.9 10.8-17.9 24.1-34.3 40.2-47.8-63.5 131.2 77.4 166 75.6 19.2zm-18.5 32.5c-1.1 7.7-3.1 15.3-6 22.5-2.1 4.9-4.8 9.6-8 13.9-2 2.5-4.3 4.7-6.7 6.8-1.8 1.3-3.7 2.4-5.7 3.4-1.6.6-3.2 1-4.9 1.3-1.6.1-3.2.1-4.8 0-1.9-.4-3.8-.9-5.6-1.6-1.8-.8-3.5-1.9-5.1-3-1.6-1.4-3.1-2.9-4.5-4.5-1.7-2.4-3.2-5-4.4-7.8-1.2-2.9-2.1-5.9-2.9-8.9-.8-3.1-1.3-6.2-1.8-9.4-1.3-10.9-1.2-22 .2-32.9 1.5-10.7 4.2-21.2 8.3-31.2.9-2 1.8-4.1 2.8-6 2.1-1.3 4.3-2.5 6.6-3.5 3.5-1.4 7.1-2.4 10.8-3.1 2.4-.2 4.7-.2 7.1-.1 1.5.3 3.1.7 4.5 1.2l2.4 1.2c.7.4 1.4.9 2.1 1.4 1.7 1.5 3.3 3.1 4.8 4.9 2.1 2.9 3.8 6.1 5.3 9.3 2.6 6.7 4.4 13.7 5.4 20.8 1.1 8.4 1.1 16.9.1 25.3zM110.1 180c0 .2 0 .4-.1.6 0-.1.1-.4.1-.6zm-52.6 44.3c1-2.3 2.1-4.4 3.2-6.6.7-1.5 1.5-2.9 2.2-4.4-.2 4.8-.3 9.5-.4 14.3-.3 11-.1 22.1-.1 33.1 0 3.5-.1 7.1-.2 10.7-.1 3.1-.4 6.3-.7 9.4-.6 4.3-1.6 8.5-3.1 12.6-.4.9-.8 1.7-1.2 2.5-.5 1-1.1 1.9-1.8 2.8-.9 1.1-2 2.2-3.1 3.1-.4.3-.8.5-1.2.7h-.4l-.8-.2c-.3-.1-.5-.3-.7-.4l-1.2-1.2c-.7-1.1-1.4-2.2-1.9-3.4-.8-2.4-1.5-4.8-1.9-7.3-.7-7.2-.5-14.5.5-21.6.4-2.6.8-5.3 1.3-7.9s1-5.1 1.7-7.6c.8-2.9 1.6-5.8 2.4-8.8.5-1.8 1-3.5 1.7-5.2.8-2.4 1.6-4.8 2.5-7.2 1.1-2.5 2.2-5 3.2-7.4zM49.8 67.1c-.1-.5-.1-1-.2-1.5 0 .5.1 1 .2 1.5zm-48 71.8z"
      />
      <path
        id="dot"
        className="st0"
        d="M34.8 15c0 8.3 6.7 15 15 15s15-6.7 15-15-6.7-15-15-15-15 6.7-15 15z"
      />
    </svg>
  );
}

export default InitialsSVG;

InitialsSVG.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.shape({}),
};

InitialsSVG.defaultProps = {
  width: '50',
  height: '50',
  style: { display: 'inline' },
};
